import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in (check localStorage)
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');
    const storedUser = localStorage.getItem('user_data');
    
    if (accessToken && refreshToken) {
      // Restore user data from localStorage
      const userData = storedUser ? JSON.parse(storedUser) : null;
      setUser({
        isAuthenticated: true,
        accessToken,
        refreshToken,
        user: userData
      });
    }
    
    setLoading(false);
  }, []);

  const login = (userData) => {
    // Store user data in localStorage for persistence
    if (userData.user) {
      localStorage.setItem('user_data', JSON.stringify(userData.user));
    }
    setUser({
      isAuthenticated: true,
      ...userData
    });
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_data');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

